<template>
  <div class="market-form" v-bind:class="{show:showCategoryList}">
    <RdsAlert
      v-if="!!alert"
      v-bind:title="alert.title"
      v-bind:text="alert.text"
      v-bind:showCancel="false"
      v-on:alertConfirm="onAlertConfirm"
    ></RdsAlert>
    <div class="market-overlay"></div>
    <section>
      <div v-on:tap="showCategoryList=!showCategoryList" class="section-title category-title">
        <span>Categoria prodotto</span>
        <span class="arrow">
          <img src="../assets/images/angle-arrow-down.svg" />
        </span>
      </div>
      <!-- CATEGORIES -->
      <div class="section-body categories">
        <div
          v-bind:class="{selected:selectedCategory===category}"
          v-on:tap="selectCategory(category)"
          class="input-container"
          v-for="category in categories"
          v-bind:key="category"
        >
          <span>{{category}}</span>
        </div>
      </div>
      <!-- CATEGORIES -->
      <div class="section-body">
        <div class="input-container">
          <input v-model="title" type="text" name="name" placeholder="Nome del prodotto" />
        </div>
        <div class="input-container">
          <input v-model="price" type="number" name="price" placeholder="Prezzo" />
        </div>
      </div>
    </section>
    <section>
      <div class="section-title">
        <span>Descrizione prodotto</span>
      </div>
      <div class="section-body">
        <div class="input-container">
          <textarea
            v-model="description"
            name="description"
            placeholder="Scrivi la descrizione del prodotto…"
          ></textarea>
        </div>
      </div>
    </section>
    <section>
      <div class="section-title">
        <span>Immagini prodotto</span>
        <input
          v-if="mainImage"
          class="file-upload"
          type="file"
          v-on:change="onFileChange"
          multiple
          accept="image/*"
        />
        <span v-if="images.length || mainImage" class="plus">
          <img src="../assets/images/add.svg" />
        </span>
      </div>
      <div class="section-body">
        <div class="image-container" v-bind:style="{backgroundImage: 'url('+mainImageUrl+')'}">
          <input
            v-if="!mainImage"
            class="file-upload"
            type="file"
            v-on:change="onFileChange"
            multiple
            accept="image/*"
          />
          <img v-if="!mainImage" src="../assets/images/icona_immagine.svg" />
        </div>
      </div>
    </section>
    <div class="images-list" v-if="images.length">
      <div class="images-list-item" v-for="(image,idx) in images" v-bind:key="idx">
        <img v-bind:src="image.base64" />
      </div>
    </div>
    <div v-on:tap="save()" class="button">Salva</div>
  </div>
</template>
<script>
import userService from '../services/User.service';
import RdsAlert from '../components/RdsAlert';
// import swipe from '../directives/swipe';
const categories = [
  'Cucina e casalinghi',
  'Decorazione e accessori',
  'Design e arredamento',
  'Giardino ed esterni',
  'Hobby',
  'Illuminazione',
  'Musica e film',
  'Sport',
  'Tecnologia'
];
export default {
  name: 'market-form',
  components: { RdsAlert },
  props: ['product'],
  data() {
    return {
      categories: categories,
      selectedCategory: null,
      showCategoryList: false,
      description: this.product ? this.product.description : '',
      price: this.product ? this.product.price : '',
      title: this.product ? this.product.title : '',
      mainImage: this.product ? this.product.photos[0] : null,
      images: this.product ? _getImages(this.product.photos) : [],
      alert: null
    };
  },
  methods: {
    save() {
      console.log('save');
      const today = new Date();
      if (this.mainImage) {
        this.images.push(this.mainImage);
      }
      const createdAt = `${today.getDate()}.${today.getMonth()}.${today.getFullYear()}`;
      const product = {
        id: !!this.product ? this.product.id : null,
        createdAt: createdAt,
        description: this.description,
        forSale: false,
        likes: [],
        photos: this.images,
        price: this.price,
        tipologia: 'marketProduct',
        title: this.title,
        user: {
          name: userService.user.name,
          id: userService.user.i
        }
      };
      if (!product.description) {
        this.alert = {
          title: 'Error',
          text: 'Inserisci la descrizione del prodotto'
        };
      } else if (!product.price) {
        this.alert = {
          title: 'Error',
          text: 'Inserisci il prezzo del prodotto'
        };
      } else if (!product.title) {
        this.alert = {
          title: 'Error',
          text: 'Inserisci il nome del prodotto'
        };
      } else if (!product.photos.length) {
        this.alert = {
          title: 'Error',
          text: 'Devi caricare almeno un immagine'
        };
      }
      if (!!this.alert) {
        return;
      }
      this.$emit('newProduct', product);
    },
    onAlertConfirm() {
      this.alert = null;
    },
    onFileChange(e) {
      console.log('onFileChange');
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      for (const file of files) {
        this.createImage(file);
      }
    },
    createImage(file) {
      // let image = new Image();
      let reader = new FileReader();
      let vm = this;

      reader.onload = e => {
        if (!vm.mainImage) {
          vm.mainImage = { base64: e.target.result, file: file };
        } else {
          this.images.push({ base64: e.target.result, file: file });
        }
      };
      reader.readAsDataURL(file);
    },
    addImage() {
      if (this.mainImage) {
        this.images.push(this.mainImage);
        this.mainImage = null;
      }
    },
    selectCategory(category) {
      this.selectedCategory = category;
      this.showCategoryList = false;
    }
  },
  computed: {
    mainImageUrl() {
      console.log(this.mainImage);
      let imageUrl = '';
      if (!!this.mainImage) {
        if (!!this.mainImage.base64) {
          imageUrl = this.mainImage.base64;
        } else {
          imageUrl = this.mainImage;
        }
      } else {
        imageUrl = '';
      }
      // return !!this.mainImage ? this.mainImage.base64 : '';
      return imageUrl;
    }
  }
};
function _getImages(photos) {
  let images = [];
  if (photos.length > 1) {
    photos.shift();
    images = photos;
  }
  return images;
}
</script>
<style lang="scss" scoped>
input,
textarea {
  border: none;
  width: 100%;
  letter-spacing: 1px;
  font-size: 0.95em;
  &::placeholder {
    color: #607d8b;
  }
}
textarea {
  height: 134px;
}
.market-form {
  position: relative;
  padding: 21px;
  letter-spacing: $default-letter-spacing;
  .market-overlay {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.63);
    display: none;
  }
  .categories {
    display: none;
    .input-container {
      padding: 18px 0;
      margin: 0 18px;
      span {
        font-size: 0.95em;
      }
      &.selected {
        color: #000000;
      }
    }
  }
  &.show {
    .arrow {
      transform: rotate(90deg);
    }
    .market-overlay {
      display: block;
    }
    .category-title {
      position: relative;
      z-index: 0;
    }
    .categories {
      display: block;
      position: relative;
      z-index: 0;
      color: rgba(0, 0, 0, 0.62);
    }
  }
}

section {
  margin-bottom: 20px;
  .section-title {
    display: flex;
    font-weight: 600;
    margin-bottom: 10px;
    background: #ffffff;
    border-radius: $default-border-radius;
    padding: 18px;
    align-items: center;
    justify-content: space-between;
    position: relative;
    .file-upload {
      position: absolute;
      width: 100%;
      height: 100%;
      opacity: 0;
      z-index: 2;
    }
  }
  .section-body {
    border-radius: $default-border-radius;
    background: #ffffff;
    .input-container {
      border-bottom: #0000000d solid 1px;
      padding: 18px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .image-container {
      position: relative;
      margin-bottom: 10px;
      display: flex;
      height: 209px;
      background-repeat: no-repeat;
      background-size: contain;
      .file-upload {
        position: absolute;
        width: 100%;
        height: 100%;
        opacity: 0;
        z-index: 2;
      }
      img {
        margin: auto;
      }
    }
  }
  .plus,
  .minus {
    display: flex;
  }
}
.images-list {
  display: flex;
  margin-bottom: 30px;
  .images-list-item {
    width: 33%;
    margin-left: 10px;
    &:nth-child(1) {
      margin-left: 0;
    }
    img {
      max-width: 100%;
      max-height: 73px;
    }
  }
}

.button {
  background-color: #a31313;
  padding: 18px;
  text-align: center;
  color: #ffffff;
  border-radius: $default-border-radius;
}
</style>
